import { Tooltip, Typography } from "@bracket/ui";
import styled from "styled-components";
import type { MetricCardProps } from "./type";

const Card = styled.div`
  display: flex;
  gap: 8px;
  padding: 24px;
  border-radius: 8px;
  background-color: var(--surface);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex-direction: column;

  @media (min-width: 768px) {
    gap: 12px;
  }
`;

const CardTitleSection = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const CardBodySection = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }
`;

export const MetricCard: React.FC<MetricCardProps> = ({
	title,
	dollarValue,
	brktValue,
	tooltipMessage,
}) => {
	return (
		<Card>
			<CardTitleSection>
				<Typography variant="paragraphSM" color="var(--text-subheading)">
					{title}
				</Typography>
				<Tooltip message={tooltipMessage} />
			</CardTitleSection>

			<CardBodySection>
				<Typography variant="h4" color="var(--text-heading-title)">
					{dollarValue}
				</Typography>
				<Typography variant="paragraphSM" color="var(--text-heading-title)">
					{brktValue}
				</Typography>
			</CardBodySection>
		</Card>
	);
};
